export const Config = {
  main_url: 'https://pagar-php.sninfosystems.com',
  mainpy_url: 'https://pagar-api.sninfosystems.com',
};
